import axios from 'axios';
import { getAuthHeaders } from '../../../services/authService';

const root = `${(process.env.REACT_APP_API_URL || '/api').replace(/\/$/, '')}/finops/servicios-cloud`;
export const entityPath = (entity, id) => `/entities/${encodeURIComponent(entity)}${id == null ? '' : `/${encodeURIComponent(id)}`}`;
export const listParams = ({ page = 1, page_size = 50, q = '', filters, ...rest } = {}) => ({
  ...rest, page: Math.max(1, Number(page) || 1), page_size: Math.min(200, Math.max(1, Number(page_size) || 50)),
  q: q.slice(0, 200), ...(filters && Object.keys(filters).length ? { filters: JSON.stringify(filters) } : {}),
});
export const cloudApi = {
  async get(path, params = {}, signal) {
    const response = await axios.get(`${root}${path}`, { params, signal, headers: getAuthHeaders() });
    return response.data;
  },
  async write(method, path, body) {
    const response = await axios.request({ method, url: `${root}${path}`, data: body, headers: getAuthHeaders() });
    return response.data;
  },
};
export function writableValues(schema, values, editing = false) {
  return Object.fromEntries(schema.columns.filter(column => !column.readonly && !(column.key && (editing || schema.auto_id)))
    .filter(column => Object.prototype.hasOwnProperty.call(values, column.name))
    .map(column => {
      const value = values[column.name];
      return [column.name, value === '' || value === undefined ? null : value];
    }));
}
export function apiError(error) {
  const detail = error.response?.data?.detail;
  const message = typeof detail === 'string' ? detail : detail ? JSON.stringify(detail) : error.message;
  return error.response?.status === 409 ? `Conflicto de version. Recarga el registro antes de volver a guardar. ${message}` : message;
}
export const isCloudAdmin = user => (user?.roles || []).some(role => String(role).trim().toLowerCase() === 'admin');
export const canAccessCloud = user => (user?.roles || []).some(role => ['admin', 'finops_gerente', 'finops_coordinador', 'finops_analista', 'finops_presupuesto'].includes(String(role).trim().toLowerCase()));
export const mexicoToday = () => {
  const parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Mexico_City', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
  return ['year', 'month', 'day'].map(type => parts.find(part => part.type === type).value).join('-');
};